import { Button as ButtonAntd } from 'antd';
import styled from 'styled-components';
import { GreenColors } from 'theme';

const ErrorContainer = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 32px;
`;

const Button = styled(ButtonAntd)`
  background-color: ${GreenColors[60]} !important;
  border-color: ${GreenColors[60]} !important;

  &.ant-btn-primary:hover,
  .ant-btn-primary:focus {
    background-color: ${GreenColors[60]} !important;
    border-color: ${GreenColors[60]} !important;
  }
`;

export { Button, ErrorContainer };
